/**
 * API Configuration
 * 
 * HARDCODED fallback to prevent .env overwrites from breaking the app.
 * Even if REACT_APP_BACKEND_URL is missing or wrong, the app will still work.
 */

export const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'https://photog-hub.emergent.host';

export const API = `${API_BASE_URL}/api`;
